module.exports = __webpack_public_path__ + "img/bg.59d0da44.jpeg";